import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsFleetPaperwork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appraisal_data: props.appraisal_data || null,
      data: props.data || null,
      isLoadingAppraisalInfo: (props.appraisal_data !== null) || false,
      jobId: props.jobId || null,
      paperwork:[]
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      appraisal_data: nextProps.appraisal_data,
      jobId: nextProps.jobId,
      paperwork:(nextProps.data.fleet_paperwork_image) ? JSON.parse(nextProps.data.fleet_paperwork_image) : [],
    });
  }
  downloadPaperworkImagesForJob(e, jobId) {
    return fetch('/api/v1/portal/jobs/download-paperwork-images'+'/'+jobId,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/zip'
        },
      }).then((responseText) => {
      let response = responseText.blob();
      response.then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          jobId+'-paperwork-images.zip'
        );
        document.body.appendChild(link);
        link.click();
      });
    });
  }
  render() {
    let appraisalFleetWorkImage = [];
    if((!this.state.isLoadingAppraisalInfo && this.state.appraisal_data && this.state.appraisal_data.manual_appraisal)){
      if(this.state.appraisal_data.manual_appraisal.pickup.paperwork){
        this.state.appraisal_data.manual_appraisal.pickup.paperwork.map((photoName,i) =>
            appraisalFleetWorkImage.push(
              <p className="col-md-4 text-center" key={'fleet-paperwork-'+i}>
                  <img src={photoName} className="job-full-details-fleet-paperwork-image img-responsive"/>
                  <strong>Pickup</strong>
              </p>
            )
          )
      }
      if(this.state.appraisal_data.manual_appraisal.dropoff.paperwork){
        this.state.appraisal_data.manual_appraisal.dropoff.paperwork.map((photoName,i) =>
            appraisalFleetWorkImage.push(
              <p className="col-md-4 text-center" key={'fleet-paperwork-'+i}>
                  <img src={photoName} className="job-full-details-fleet-paperwork-image img-responsive"/>
                  <strong>Dropoff</strong>
              </p>
            )
          )
      }
      // if((this.state.appraisal_data.paperwork.complete)){
      //   if(this.state.appraisal_data.paperwork.uploadcare_image_urls){
      //     this.state.appraisal_data.paperwork.uploadcare_image_urls.map((photoName,i) =>
      //       appraisalFleetWorkImage.push(
      //         <p className="col-md-4" key={'fleet-paperwork-'+i}>
      //             <img src={photoName}className="job-full-details-fleet-paperwork-image img-responsive"/>
      //         </p>
      //       )
      //     )
      //   }else{
      //       this.state.appraisal_data.paperwork.photo_names.map((photoName,i) =>
      //         appraisalFleetWorkImage.push(
      //             <p className="col-md-4" key={'fleet-paperwork-'+i}>
      //               <img src={"/storage/images/jobs/"+this.state.jobId+"/fleet_paperwork/"+photoName} className="job-full-details-fleet-paperwork-image img-responsive"/>
      //             </p>
      //           )
      //       )
      //     }
      //   }
        // if(!this.state.isLoadingAppraisalInfo && this.state.paperwork && this.state.paperwork.paperwork){
        //   this.state.paperwork.paperwork.map((photoName,i) =>
        //     appraisalFleetWorkImage.push(
        //       <p className="col-md-4" key={'fleet-paperwork-'+i}>
        //           <img src={photoName}className="job-full-details-fleet-paperwork-image img-responsive"/>
        //       </p>
        //     )
        //   )
        // }
    }
    
    return (
      <div className="jobs-table-fleet-paperwork-container">
        <h2>Waste Transfer Note</h2>
        <div>
          <a href="#"
              onClick={(e) => {
                this.downloadPaperworkImagesForJob(
                  e,
                  this.state.data.id
                )
              }}
              disabled={appraisalFleetWorkImage.length > 0 ? true : false}
              className="btn btn-lg btn-success appraisal-download-button">
            <i className="fa fa-download"></i> Download Paperwork Images as .zip
          </a>
        </div>
        {
          (!this.state.isLoadingAppraisalInfo &&
            this.state.data &&
            this.state.data.fleet_paperwork_image) ?
            <div className="row">
              {appraisalFleetWorkImage}
            </div>
            :
            <div>
              {this.state.data.fleet_paperwork_required ?
                <strong>Waste Transfer Note required and not here yet</strong>
                :
                <strong>Waste Transfer Note not required</strong>
              }
            </div>
        }
      </div>
    )
  }
}